import FirstPlaceIcon from 'assets/images/icon-first-place.svg'
import SecondPlaceIcon from 'assets/images/icon-second-place.svg'
import ThirdPlaceIcon from 'assets/images/icon-third-place.svg'
import RandomPrizeIcon from 'assets/images/random-prize.png'

import { FC, memo } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
import IQuiz from 'models/Quiz';
import IResult from 'models/Result';
// Utilities
import { buildUserName, getEndOfPlace } from 'utilities/Utilities';
// Components
import Word from './Word';

import classes from './styles.module.css';
import useCompactLayout from 'hooks/useCompactLayout';

type Props = {
  result: IResult;
  resultIndex: number;
  randomPrize?: boolean;
}

const ResultItem:FC<Props> = ({ result, resultIndex, randomPrize = false }) => {
  const icons = [FirstPlaceIcon, SecondPlaceIcon, ThirdPlaceIcon];
  const isCompact = useCompactLayout();

  const quizResult:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || quizResult?.quiz || null;

  const primaryColor = quizResult.quizGroup ? quizResult.quizGroup.publicLeaderboard.primaryColor
    : quiz?.publicLeaderboard.primaryColor;

  return (
    <li
      className={`flex items-center font-medium uppercase ${classes.resultItem} ${isCompact ? 'pb-0 px-3 gap-2' : 'pb-2 mb-2 xl:mb-6 px-4 gap-1 sm:text-3xl'}`}
    >
      <div className="flex-1 min-w-0 flex items-center gap-2">
        <div className={`flex justify-center shrink-0 ${isCompact ? 'w-9' : 'w-12 sm:w-32'}`}>
          {resultIndex > 2 ? (
            randomPrize ? (
              <img src={RandomPrizeIcon} alt="Random-Prize" className={isCompact ? 'h-7' : 'h-11'} />
            ) : (
              <span style={{ color: primaryColor }}>{`${result.position}${getEndOfPlace(result.position)}`}</span>
            )
          ) : (
            <img src={icons[resultIndex]} alt={`Prize-${resultIndex + 1}`} className={isCompact ? 'h-7' : `${resultIndex === 0 ? 'h-12' : 'h-9'}`} />
          )}
        </div>
        <div className="flex-1 min-w-0 truncate">
          <Word word={buildUserName(result)} />
        </div>
      </div>
      <div className="shrink-0">
        <Word word={`${result.score.toLocaleString('en-US')} PTS`} />
      </div>
    </li>
  );
}

export default memo(ResultItem);
